<template>
  <svg
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector 44"
      d="M1 13L6.29289 7.70711C6.68342 7.31658 6.68342 6.68342 6.29289 6.29289L0.999999 1"
      stroke="#110F13"
      stroke-linecap="round"
    />
  </svg>
</template>
